import enUS from './en-US.json';
import zhCN from './zh-CN.json';

export const DEFAULT_LOCALE = 'en-US';
export const FALLBACK_LOCALE = 'en-US';

export const SUPPORTED_LOCALES = ['en-US', 'zh-CN'];

export const messages = {
  'en-US': enUS,
  'zh-CN': zhCN
};

/**
 * Resolve any incoming locale string to one of the supported locales.
 * Examples:
 *  - "en"     -> "en-US"
 *  - "en-GB"  -> "en-US"
 *  - "zh"     -> "zh-CN"
 *  - "zh-TW"  -> "zh-CN"
 *
 * @param {string | null | undefined} localeCandidate - Locale string from storage or browser.
 * @returns {string} One of the supported locale codes.
 */
export function resolveLocale(localeCandidate) {
  if (!localeCandidate || typeof localeCandidate !== 'string') {
    return DEFAULT_LOCALE;
  }

  const normalized = localeCandidate.trim().toLowerCase();

  if (normalized.startsWith('zh')) {
    return 'zh-CN';
  }

  if (normalized.startsWith('en')) {
    return 'en-US';
  }

  return DEFAULT_LOCALE;
}

export default messages;
